export default __webpack_public_path__ + "static/media/anisha-matharu-and-sabrina-moin-640.5bd34bb9.jpg";